module.exports = __webpack_public_path__ + "static/img/yytx27.f8f2e7a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx27.png
// module id = 896
// module chunks = 0